import React from 'react';
import { StyledFooter } from './styles';

interface DrawerFooterProps {
  ghost?: boolean;
}

const DrawerFooter: React.FC<React.PropsWithChildren<DrawerFooterProps>> = ({
  ghost,
  children,
}) => <StyledFooter $ghost={ghost}>{children}</StyledFooter>;

export { DrawerFooter };
